export default [
  {
    path: "/home", // 主页
    component: () => import("@/views/pc/Home"),
    meta: {
      keepAlive: true,
      auth: true
    },
    children: [
      {
        path: "/",
        name: "HomeIndex",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/HomeIndex")
      },
      {
        path: "myOrder",
        name: "MyOrder",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/MyOrder")
      },
      {
        path: "myAddress",
        name: "MyAddress",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/MyAddress")
      },
      {
        path: "addAddress",
        name: "AddAddress",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/AddAddress")
      },
      {
        path: "verifyCenter",
        name: "VerifyCenter",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/VerifyCenter")
      },
      {
        path: "orderDetail/:id",
        name: "orderDetail",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () => import("@/components/pc/order/OrderDetail")
      },
      {
        path: "contactUs",
        name: "ContactUs",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/ContactUs")
      },
      {
        path: "myBalance",
        name: "MyBalance",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/MyBalance")
      },
      // 修改密码
      {
        path: "changePassword",
        name: "ChangePassword",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/ChangePassword")
      },
      // 产品收藏
      {
        path: "goodsCollection",
        name: "GoodsCollection",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/GoodsCollection")
      },
      // 推广中心
      {
        path: "myPromotion",
        name: "MyPromotion",
        meta: {
          keepAlive: true,
          auth: true
        },
        component: () => import("@/components/pc/home/MyPromotion")
      },
      // 推广分享图
      {
        path: "businessCard",
        name: "BusinessCard",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () => import("@/components/pc/home/promotion/BusinessCard")
      },
      // 推广人统计
      {
        path: "businessTotal",
        name: "BusinessTotal",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () => import("@/components/pc/home/promotion/BusinessTotal")
      },
      //团队人数
      {
        path: "groupMemberList",
        name: "GroupMemberList",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () =>
          import("@/components/pc/home/promotion/GroupMemberList")
      },
      //添加醫生
      {
        path: "addDoctor",
        name: "addDoctor",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () => import("@/components/pc/home/addDoctor")
      },
      //个人信息编辑
      {
        path: "editPersonal",
        name: "editPersonal",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () => import("@/components/pc/home/editPersonal")
      },
      // 推广人订单
      {
        path: "businessOrder",
        name: "BusinessOrder",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () => import("@/components/pc/home/promotion/BusinessOrder")
      },
      // 编辑下级信息
      {
        path: "businessUserInfo",
        name: "businessUserInfo",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () =>
          import("@/components/pc/home/promotion/BusinessUserInfo")
      },
      //物流详情
      {
        path: "expressInfo/:id",
        name: "expressInfo",
        meta: {
          keepAlive: false,
          auth: true
        },
        component: () => import("@/components/pc/order/expressInfo")
      }
    ]
  }
];
